import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { apiFetch } from '../modules/utility';
import { showErrors } from '../modules/general';

const apiBase = 'admin';

const getBrowserAuthCode = ({params = {}, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.getBrowserAuthCode`,
			params,
			dispatch,
			callback,
		});
	};
};

const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = dispatch => bindActionCreators({
	getBrowserAuthCode,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);